import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-api-endpoint-with-keys',
  templateUrl: './userapi-api-endpoint-with-keys.component.html'
})
export class UserApiApiEndpointWithKeysComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;
}
